import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy, Location, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { Theme } from './shared/service/AutoTheme';
import { JwtInterceptor } from './authentication/helper/jwt.interceptor';
import { AuthGuard } from './authentication/guard/auth.guard';
import { AuthenticationService } from './authentication/authentication.service';
import { ErrorInterceptor } from './authentication/helper/error.interceptor';
import { ServerSocket } from './shared/service/Activity.socket';
import { QuillModule } from 'ngx-quill'
import { SharedModule } from './shared/shared.module';
import { DemoMaterialModule } from './demo-material-module';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { MatStepperModule } from '@angular/material';
import { SPSmtpService } from './profile/profile.service';
import { WizardModule } from './wizard/wizard.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {MatFormFieldModule,MatInputModule} from '@angular/material';
import { KycModule } from './kyc/kyc.module';


import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    NavigationComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    HttpModule,
    SharedModule,
    DemoMaterialModule,
    QuillModule,
    WizardModule,
    ReactiveFormsModule,
    MatStepperModule,
    ScrollingModule,
    MatFormFieldModule,
    KycModule,
    MatIconModule,

   ],

  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthenticationService, Theme, AuthGuard, ServerSocket, SPSmtpService,
    Location, {provide: LocationStrategy, useClass: PathLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
